import Swiper from "swiper";

export default ({ hint = false } = {}) => ({
  swiper: null,
  hint,
  hinting: false,

  initSlider() {
    this.swiper = new Swiper(this.$refs.slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      rewind: true,
    });

    this.swiper.on("touchStart", () => {
      this.hinting = false;
    });
  },

  async hintSwipe() {
    await this.$nextTick();

    if (!this.hint || this.hinting) return;
    if (!this.swiper || this.swiper.slides.length < 2) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    await this.imagesReady();
    await this.wait(400);

    this.swiper.update();
    this.hinting = true;

    const peek = this.swiper.width * 0.8;
    const out = 600;
    const back = 600;
    const hold = 250;

    for (let i = 0; i < 2 && this.hinting; i++) {
      this.swiper.translateTo(-peek, out);
      await this.wait(out + hold);
      if (!this.hinting) return;

      this.swiper.translateTo(0, back);
      await this.wait(back + hold);
    }

    this.hinting = false;
  },

  imagesReady() {
    const images = [...this.$el.querySelectorAll(".swiper-slide img")].slice(
      0,
      2
    );

    return Promise.all(
      images.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.addEventListener("load", resolve, { once: true });
              img.addEventListener("error", resolve, { once: true });
            })
      )
    );
  },

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
});
